var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2ZM8 6.71387C7.52666 6.71387 7.14265 7.09797 7.14258 7.57129V11C7.14258 11.4734 7.52661 11.8574 8 11.8574C8.47339 11.8574 8.85742 11.4734 8.85742 11V7.57129C8.85735 7.09797 8.47334 6.71387 8 6.71387ZM8 4.14258C7.52661 4.14258 7.14258 4.52661 7.14258 5C7.14258 5.47339 7.52661 5.85742 8 5.85742C8.47339 5.85742 8.85742 5.47339 8.85742 5C8.85742 4.52661 8.47339 4.14258 8 4.14258Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.5a8b5c1af10a888ac0e8ccf01efd6d01.svg";
export { ForwardRef as ReactComponent };